const canUseDOM = !!(
  typeof window !== "undefined" &&
  window.document &&
  window.document.createElement
);

export default canUseDOM;



//////////////////
// WEBPACK FOOTER
// ./node_modules/inputmask/lib/canUseDOM.js
// module id = 4417
// module chunks = 0